// exportar função que recebe um país e retorna os dados
import AR from './AR'
import BR from './BR'
import CO from './CO'
import MX from './MX'
import PE from './PE'

const regionData = {
  BR,
  AR,
  CO,
  MX,
  PE
}

type AvailableCountries = keyof typeof regionData

export const getRegionData = (country: AvailableCountries | string) =>
  regionData?.[country as AvailableCountries] || null
